import React from "react";
import TableDataList from "./TableDataList";
interface ListWrapperProps {
  data: any[];
  context: string;
  onRowAction?: (action: string, row: any) => void;
  selectedRowItem?: any | null;
  onRowSelect?: (row: any | null, index: number) => void;
  currentRecord?: (index: number) => void;
  pagination?: { pageIndex: number; pageSize: number };
  setPagination?: (pagination: { pageIndex: number; pageSize: number }) => void;
  globalFilter?: string;
  setGlobalFilter?: (filter: string) => void;
  rowCount?: number;
  // Drives the search field rendered in the table's toolbar. Owned by the page
  // so the keyword outlives the table remounting between loads.
  search?: {
    input: string;
    applied: string;
    minLength: number;
    canApply: boolean;
    onInputChange: (value: string) => void;
    onApply: () => void;
    onClear: () => void;
  };
}

const ListWrapper: React.FC<ListWrapperProps> = ({
  data,
  context,
  onRowAction = (action, row) => console.log(`${action} row:`, row), // Default handler
  selectedRowItem,
  onRowSelect,
  currentRecord,
  pagination,
  setPagination,
  globalFilter,
  setGlobalFilter,
  rowCount,
  search,
}) => {
  return (
    <TableDataList
      context={context}
      data={data}
      handleRowAction={onRowAction}
      selectedRowItem={selectedRowItem}
      setCurrentRecord={currentRecord}
      pagination={pagination}
      setPagination={setPagination}
      globalFilter={globalFilter}
      setGlobalFilter={setGlobalFilter}
      rowCount={rowCount}
      search={search}
    />
  );
};

export default ListWrapper;
